import * as React from "react";
function SvgFacebookReactionAngry(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <defs>
        <linearGradient
          x1={24}
          y1={2}
          x2={24}
          y2={50}
          gradientTransform="matrix(1 0 0 -1 0 50)"
          gradientUnits="userSpaceOnUse"
          id="facebook-reaction-angry_svg__a"
        >
          <stop offset={0.06} stopColor="#ffd974" />
          <stop offset={0.19} stopColor="#fdce74" />
          <stop offset={0.45} stopColor="#f7ac70" />
          <stop offset={0.78} stopColor="#ef786b" />
          <stop offset={1} stopColor="#ea5167" />
        </linearGradient>
      </defs>
      <circle
        cx={24}
        cy={24}
        r={24}
        fill="url(#facebook-reaction-angry_svg__a)"
      />
      <path
        d="M24 36.73c-4.14 0-7.5.42-7.5 1.75s3.36 1.28 7.5 1.28 7.5 0 7.5-1.28-3.4-1.75-7.5-1.75zm-3.78-6.09a1.09 1.09 0 100-2.18c-9.38-.22-12.78-2.71-12.85-2.77A1.1 1.1 0 006 27.4a14.16 14.16 0 004.91 2.06 3 3 0 105.44.94c1.18.13 2.44.21 3.83.24zm21.88-4.77a1.09 1.09 0 00-1.53-.17s-3.43 2.54-12.84 2.76a1.09 1.09 0 000 2.18 35.93 35.93 0 003.8-.23 3 3 0 105.47-.94 14.15 14.15 0 004.91-2.06 1.09 1.09 0 00.16-1.53z"
        fill="#282c39"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookReactionAngry);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
